angular.module('login.forgot', [
  'security.service',
  'services.utility',
  'ui.bootstrap'])
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state('login-forgot', {
        url: '/login/forgot',
        views: {
          header: {
            template: require('../../common/header/header.tpl.html'),
            resolve: {
              user: ["User", "$q", "$timeout", "$state", function (User,$q, $timeout, $state) {
                return User.current(function (user) {
                  if (user._id) {
                    $timeout(function() {
                      $state.go('account')
                    })
                    return $q.reject()
                  }
                  return user
                }).$promise;
              }],
            },
            controller: 'HeaderCtrl'
          },
          main: {
            template: require('./login-forgot.tpl.html'),
            controller: 'LoginForgotCtrl',
            title: 'Forgot Your Password ?'
          },
          footer: {
            template: require('../../common/footer/footer.tpl.html'),
            controller: 'FooterCtrl'
          }
        },
      });
  }])
  .controller('LoginForgotCtrl', ['$scope', '$location', '$log', 'security', 'utility',
    function ($scope, $location, $log, security, utility) {
      // local variable
      var resetSuccess = function (data) {
        $scope.loginForgotForm.$setPristine();
        $scope.user = {};
        if (data) {
          $scope.alerts.push({
            type: 'info',
            msg: 'If an account matched that address, an email will be sent with instructions.'
          });
        } else {
          angular.forEach(data.errors, function (err, index) {
            $scope.alerts.push({
              type: 'danger',
              msg: err
            });
          });
        }
      };
      var resetError = function () {
        $scope.alerts.push({
          type: 'danger',
          msg: 'Error resetting your account, Please try again'
        });
      };
      // model def
      $scope.user = {};
      $scope.alerts = [];

      // method def
      $scope.hasError = utility.hasError;
      $scope.showError = utility.showError;
      $scope.canSave = utility.canSave;
      $scope.closeAlert = function (ind) {
        $scope.alerts.splice(ind, 1);
      };
      $scope.submit = function () {
        security.loginForgot($scope.user).then(resetSuccess, resetError);
      };
    }]);



// WEBPACK FOOTER //
// ./client/src/app/login/forgot/login-forgot.js